import   MainStyle  from "components/UI/main.module.scss";
import { useState } from 'react';
import { GetLabel } from "Utilities/utils";

// This will manage the modal state globally
let showActionMessageCallback = null;
let hideActionMessageCallback = null;
let appLang                   = null;

export const useActionModal = () => {
  return { showActionMessage: showActionMessageCallback, hideActionMessage: hideActionMessageCallback };
};

export const ActionConfirmationModal = () => {
  const [displayModal, setDisplayModal] = useState(false);
  const [messageBody, setMessageBody] = useState({ header: '', message: '' });
  const [confirmAction, setConfirmAction] = useState(() => () => {}); // Store confirm callback

  // Assign the callbacks globally to control the modal.
  showActionMessageCallback = ({ header, message }, { confirm_action }) => {
    setMessageBody({ header, message });
    setConfirmAction(() => () => {
      confirm_action();
      setDisplayModal(false);
    });
    setDisplayModal(true);
  };

  hideActionMessageCallback = () => setDisplayModal(false);

  const closePopUp = () => setDisplayModal(false);

  return (
    <>
      {displayModal && (
        <div className={[MainStyle.modal].join(" ")}>
          <div className={[MainStyle.modal_dialog].join(" ")}>
            <div className={[MainStyle.modal_content, MainStyle.rounded_3, MainStyle.shadow_sm, MainStyle.border, MainStyle.bg_card, MainStyle.mx_3].join(" ")}>
              <div className={MainStyle.m_3}>
                <div className={MainStyle.modal_header}>
                  <span className={[MainStyle.my_2, MainStyle.text_body, MainStyle.fs_4, MainStyle.fw_semibold].join(" ")}>
                    {messageBody.header}
                  </span>
                </div>
                <div className={MainStyle.modal_body}>
                  <span className={[MainStyle.text_body, MainStyle.fs_6].join(" ")}>
                    {messageBody.message}
                  </span>
                </div>
                <div className={MainStyle.my_3}></div>
                <div className={MainStyle.row}>
                  <div className={MainStyle.col_lg_7}></div>
                  <div className={MainStyle.col_lg_2}>
                    <div className={[MainStyle.pt_3].join(" ")}>
                        <button
                          style={{width: '100%'}}
                          className={[MainStyle.btn_green, MainStyle.rounded_3, MainStyle.border, MainStyle.shadow_sm, MainStyle.fs_6, MainStyle.text_white, MainStyle.py_3, MainStyle.px_3].join(" ")}
                          onClick={confirmAction}
                        >
                          {GetLabel(appLang, 52)}
                        </button>
                      </div>
                  </div>
                  <div className={MainStyle.col_lg_1}></div>
                  <div className={MainStyle.col_lg_2}>
                    <div className={[MainStyle.mt_3].join(" ")}>
                        <button
                          style={{width: '100%'}}
                          className={[MainStyle.btn_blue, MainStyle.rounded_3, MainStyle.border, MainStyle.shadow_sm, MainStyle.fs_6, MainStyle.text_white, MainStyle.py_3, MainStyle.px_3].join(" ")}
                          onClick={closePopUp}
                        >
                          {GetLabel(appLang, 53)}
                        </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

